import {
  Chip,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  Stack,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from '@mui/material';
import {
  convertIsoToReadableDate,
  convertIsoToReadableTime,
} from '../../../../components/Utilities/HelperMethods';
import NameChip from '../../../../components/Chips/NameChip';

const RequestDetailsModal = ({
  requestDetailsModalOpen,
  selectedRequest,
  toggleRequestDetailsModal,
  requestHistory,
}) => {
  return (
    <Dialog open={requestDetailsModalOpen} onClose={toggleRequestDetailsModal}>
      <DialogTitle>Request Details</DialogTitle>
      <DialogContent
        sx={{ display: 'flex', flexDirection: 'column', gap: '1rem', flexWrap: 'wrap' }}
      >
        <Stack direction={'column'}>
          <Typography variant="caption">Agent</Typography>
          {!selectedRequest.FirstName || !selectedRequest.LastName ? (
            <Chip
              label="No details available"
              variant="outlined"
              sx={{ maxWidth: 'fit-content' }}
            />
          ) : (
            <NameChip
              fullName={
                selectedRequest.FirstName && selectedRequest.LastName
                  ? `${selectedRequest.FirstName} ${selectedRequest.LastName}`
                  : ''
              }
            />
          )}
        </Stack>
        <Stack flexDirection={'column'}>
          <Typography variant="caption">NPN</Typography>
          <Chip
            sx={{ textTransform: 'capitalize', maxWidth: 'fit-content' }}
            variant="outlined"
            label={
              selectedRequest.NationalProducerNumber
                ? `${selectedRequest.NationalProducerNumber}`
                : 'No details available'
            }
          />
        </Stack>
      </DialogContent>
      <DialogTitle>Request History</DialogTitle>
      <DialogContent>
        <TableContainer sx={{ maxHeight: 400 }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>Status</TableCell>
                <TableCell>Status Date</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {requestHistory.map((request) => (
                <TableRow key={request.historyID}>
                  <TableCell>
                    <Chip
                      variant="outlined"
                      label={request.statusName}
                      color={
                        request.statusName.includes('Complete')
                          ? 'success'
                          : request.statusName.includes('Rejected')
                            ? 'error'
                            : 'default'
                      }
                    />
                  </TableCell>
                  <TableCell>
                    {convertIsoToReadableDate(request.statusDate)}{' '}
                    {convertIsoToReadableTime(request.statusDate, {
                      hour: 'numeric',
                      minute: 'numeric',
                      hour12: true,
                    })}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
    </Dialog>
  );
};

export default RequestDetailsModal;
